module.exports = __webpack_public_path__ + "static/media/about-banner@mobile-niks.db86a0c0.png";